import { render, staticRenderFns } from "./ContentChipsList.vue?vue&type=template&id=4f44cd50"
import script from "./ContentChipsList.vue?vue&type=script&lang=js"
export * from "./ContentChipsList.vue?vue&type=script&lang=js"
import style0 from "./ContentChipsList.vue?vue&type=style&index=0&id=4f44cd50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports